module.exports = __webpack_public_path__ + "static/media/blueWBlogo.53719de9.svg";